import styled from '@emotion/styled';

import { neutrals } from '@widget/toolbox/style/theme/common/ThemeProvider/colors';

export const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-radius: 4px;
  border: 0.5px solid ${neutrals.lighter};
  box-shadow: 0px 1px 6px 0px #00000026;
`;

export const StyledImg = styled.img`
  max-width: 180px;
  max-height: 80px;
  object-fit: cover;
`;
